export default __webpack_public_path__ + "media/flags/sx-c2970bc4.svg";